

<template>

    <div :class=" menuClasses " >

        <div>

            <div class="sidenav-header">

                <font-awesome-icon class="icon-class fa-3x" id="settings-icon" icon="times" @click=" toggleSideNav "></font-awesome-icon>
                <h3 v-if=" profileInfo.userId != null ">{{ profileInfo.prepaidAccount.prepaidAccountBalance }} points</h3>
                <h3 v-else>Maoz Orders</h3>
            </div>

            <ul>

                <li v-for=" ( navItem, key ) in navLynx " :key=" key ">
                    <a @click=" sideNavRouting( navItem.link )"> {{ navItem.label }} </a>
                </li>
            </ul>

            <div class="sidenav-footer">

                <h3 v-if=" isAuth  " @click=" sideNavRouting( 'settings' ) ">Settings</h3>
                <h3 v-if=" !isAuth " @click=" sideNavRouting( 'signin'   ) ">Sign In</h3>
                <h3 v-if=" isAuth  " @click=" sideNavRouting( 'profile'  ) ">Profile</h3>
                <h3 v-if=" isAuth  " @click=" logout ">Sign Out</h3>
            </div>

        </div>

    </div>

</template>

<script>

    import { mapGetters, mapActions } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

    export default {
        name: 'menuList',
        methods: {
            ...mapActions({

                logout         : 'auth/signout',
                toggleSideNav  : 'nav/toggleSideNav',
                sideNavRouting : 'nav/sideNavRouting'
            })
        },
        computed: {
            ...mapGetters({

                isAuth      : 'auth/isAuth',
                sideNavOpen : 'nav/sideNavOpen',
                profileInfo : 'auth/profileInfo',
                navLynx     : 'nav/navLynx'
            }),
            menuClasses (){

                const classes = [ 'sidenav-base' ];
                classes.push( ( this.sideNavOpen ) ? 'open' : 'closed' );
                return classes.join( ' ' );
            }
        },
        components: {

            FontAwesomeIcon
        }
    }

</script>

<style scoped>

    .icon-class{

        cursor: pointer;
        padding-right: 10px;
        color: #dacaca;
    }

    .sidenav-base{

        background-color: white;
        transition: all 0.3s;

        position: fixed;
        height: 100%;
        top: 0; bottom: 0;
        z-index: 750;
        width: 265px;
    }

    .sidenav-base > div{

        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .closed{

        right: -300px;
    }

    .open{

        right: 0px;
    }

    .sidenav-header{

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;

        flex: 1;
        border-bottom: 2px solid #174351;
        background-color: #141b1f;
    }

    .sidenav-header > h3{

        padding-right: 10px;
        color: #d5caca;
    }

    ul{

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-end;

        padding-right: 10px;
        flex: 2;
        list-style: none;
        margin: 0;
        color: #141b1f;
        font-size: 1.6rem;
        font-weight: 600;
    }
    ul:after,
    ul:before {

        content: '';
        display: block;
    }

    .sidenav-footer{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;

        flex: 1;
        border-top: 2px solid #174351;
        background-color: #141b1f;
    }

    .sidenav-footer > h3{
        padding-right: 10px;
        color: #d5caca;
        cursor: pointer;
    }

    @media screen and ( min-width: 420px ){


        .open{
            left: 0;
        }
        .closed{
            left: -300px;
        }
        .sidenav-header{

            align-items: flex-start;

        }

        .icon-class{

            padding-left: 10px;

        }

        .sidenav-header > h3{

            padding-left: 10px;

        }

        ul{

            align-items: flex-start;
            padding-left: 10px;

        }

        .sidenav-footer{

            align-items: flex-start;

        }

        .sidenav-footer > h3{

            padding-left: 10px;

        }

    }

</style>